// extracted by mini-css-extract-plugin
export default {"Background":"Background_Background__mz2VG","zoom":"Background_zoom__T1PZW"};